import React from "react";
import BackButton from "../Buttons/BackButton";
import { useNavigate } from "react-router-dom";
import { IconButton, Box, AbsoluteCenter } from "@chakra-ui/react";
import KnownWords from "../HomeHeader/KnownWords";
import Droplets from "../HomeHeader/Droplets";
import { haptic } from "@/lib/haptic";
import { IoHome } from "react-icons/io5";

interface LessonHeaderProps {
  handleBack: () => void;
  pulse: boolean;
}

export const LessonHeaderHeightPx = 40;

const LessonHeader: React.FC<LessonHeaderProps> = ({ handleBack, pulse }) => {
  const nav = useNavigate();
  return (
    <Box width={"100%"} position={"relative"} className=" bg-[#fafafa]">
      <div
        className={`flex flex-row items-center justify-between w-full z-10 relative pr-2`}
        style={{
          height: `${LessonHeaderHeightPx}px`,
        }}
      >
        <div className="flex flex-row items-center gap-2">
          <BackButton onBack={handleBack} color={"black"} />
        </div>
        <div className="flex flex-row items-center justify-end gap-1">
          <KnownWords />
          <Droplets pulse={pulse} />
        </div>
        <AbsoluteCenter
          axis={"horizontal"}
          verticalAlign={"middle"}
          zIndex={10}
        >
          <IconButton
            icon={<IoHome className="w-7 h-7" />}
            variant="ghost"
            aria-label="home"
            onClick={() => {
              haptic.soft();
              nav("/home/learn");
            }}
            _hover={{ bg: "transparent" }}
          />
        </AbsoluteCenter>
      </div>
    </Box>
  );
};

export default LessonHeader;
